<template xmlns="http://www.w3.org/1999/html">
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <InputRadioGroup
            name="where_complete_education"
            :required="checkIsRequired('where_complete_education')"
            :error="formRef.errors.get('where_complete_education')"
            v-model="formRef.where_complete_education"
            :options="getField('where_complete_education').options"
            @input='handleRegionClear'
        >
            <template v-slot:question>
                {{ getField("where_complete_education").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="['England', 'Northern Ireland'].includes(formRef.where_complete_education)"
            name="highest_qualification_england_northern_ireland"
            :required="checkIsRequired('highest_qualification_england_northern_ireland')"
            :error="formRef.errors.get('highest_qualification_england_northern_ireland')"
            v-model="formRef.highest_qualification_england_northern_ireland"
            :options="getField('highest_qualification_england_northern_ireland').options"
            @input="formRef.errors.clear('highest_qualification_england_northern_ireland')"
        >
            <template v-slot:question>
                {{ getField("highest_qualification_england_northern_ireland").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.where_complete_education === 'Scotland'"
            name="highest_qualification_scotland"
            :required="checkIsRequired('highest_qualification_scotland')"
            :error="formRef.errors.get('highest_qualification_scotland')"
            v-model="formRef.highest_qualification_scotland"
            :options="getField('highest_qualification_scotland').options"
            @input="formRef.errors.clear('highest_qualification_scotland')"
        >
            <template v-slot:question>
                {{ getField("highest_qualification_scotland").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.where_complete_education === 'Wales'"
            name="highest_qualification_wales"
            :required="checkIsRequired('highest_qualification_wales')"
            :error="formRef.errors.get('highest_qualification_wales')"
            v-model="formRef.highest_qualification_wales"
            :options="getField('highest_qualification_wales').options"
            @input="formRef.errors.clear('highest_qualification_wales')"
        >
            <template v-slot:question>
                {{ getField("highest_qualification_wales").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="['England', 'Northern Ireland', 'Wales'].includes(formRef.where_complete_education) &&
            (['Level 2 e.g. GCSEs (5-9/A*-C)'].includes(formRef.highest_qualification_england_northern_ireland)) ||
            ['Level 2 e.g. GCSEs (5-9/A*-C)'].includes(formRef.highest_qualification_wales )"
            name="achieved_five_gcses"
            :required="checkIsRequired('achieved_five_gcses')"
            :error="formRef.errors.get('achieved_five_gcses')"
            v-model="formRef.achieved_five_gcses"
            :options="getField('achieved_five_gcses').options"
            @input="formRef.errors.clear('achieved_five_gcses')"
        >
            <template v-slot:question>
                {{ getField("achieved_five_gcses").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="['England', 'Northern Ireland', 'Wales'].includes(formRef.where_complete_education) &&
            (['Level 2 e.g. GCSEs (5-9/A*-C)'].includes(formRef.highest_qualification_england_northern_ireland)) ||
            ['Level 2 e.g. GCSEs (5-9/A*-C)'].includes(formRef.highest_qualification_wales)"
            name="has_gcse_english"
            :required="checkIsRequired('has_gcse_english')"
            :error="formRef.errors.get('has_gcse_english')"
            v-model="formRef.has_gcse_english"
            :options="getField('has_gcse_english').options"
            @input="formRef.errors.clear('has_gcse_english')"
        >
            <template v-slot:question>
                {{ getField("has_gcse_english").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="['England', 'Northern Ireland', 'Wales'].includes(formRef.where_complete_education) &&
            (['Level 2 e.g. GCSEs (5-9/A*-C)'].includes(formRef.highest_qualification_england_northern_ireland)) ||
            ['Level 2 e.g. GCSEs (5-9/A*-C)'].includes(formRef.highest_qualification_wales)"
            name="has_gcse_maths"
            :required="checkIsRequired('has_gcse_maths')"
            :error="formRef.errors.get('has_gcse_maths')"
            v-model="formRef.has_gcse_maths"
            :options="getField('has_gcse_maths').options"
            @input="formRef.errors.clear('has_gcse_maths')"
        >
            <template v-slot:question>
                {{ getField("has_gcse_maths").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.highest_qualification_scotland === 'Level 5 e.g. National 5, SVQ Lvl 2'"
            name="achieved_five_or_more_intermediate"
            :required="true"
            :error="formRef.errors.get('achieved_five_or_more_intermediate')"
            v-model="formRef.achieved_five_or_more_intermediate"
            :options="getField('achieved_five_or_more_intermediate').options"
            @input="formRef.errors.clear('achieved_five_or_more_intermediate')"
        >
            <template v-slot:question>
                {{ getField("achieved_five_or_more_intermediate").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.highest_qualification_scotland === 'Level 5 e.g. National 5, SVQ Lvl 2'"
            name="has_intermediate_english"
            :required="true"
            :error="formRef.errors.get('has_intermediate_english')"
            v-model="formRef.has_intermediate_english"
            :options="getField('has_intermediate_english').options"
            @input="formRef.errors.clear('has_intermediate_english')"
        >
            <template v-slot:question>
                {{ getField("has_intermediate_english").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.highest_qualification_scotland === 'Level 5 e.g. National 5, SVQ Lvl 2'"
            name="has_intermediate_maths"
            :required="true"
            :error="formRef.errors.get('has_intermediate_maths')"
            v-model="formRef.has_intermediate_maths"
            :options="getField('has_intermediate_maths').options"
            @input="formRef.errors.clear('has_intermediate_maths')"
        >
            <template v-slot:question>
                {{ getField("has_intermediate_maths").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="formRef.highest_qualification_england_northern_ireland === 'Level 5+ e.g. HND, Degree'
            || formRef.highest_qualification_wales === 'Level 5+ e.g. HND, Degree'
            || formRef.highest_qualification_scotland === 'Level 5+ e.g. HND, Degree'"
            :required="true"
            name="level_5_qualification"
            :error="formRef.errors.get('level_5_qualification')"
            v-model="formRef.level_5_qualification"
            :options="getField('level_5_qualification').options"
            @input="formRef.errors.clear('level_5_qualification')"
        >
            <template v-slot:question>
                {{ getField("level_5_qualification").question }}
            </template>
        </InputRadioGroup>

        <InputText
            name="level_5_qualification_subject"
            :required="true"
            v-if="formRef.highest_qualification_england_northern_ireland === 'Level 5+ e.g. HND, Degree'
            || formRef.highest_qualification_wales === 'Level 5+ e.g. HND, Degree'
            || formRef.highest_qualification_scotland === 'Level 5+ e.g. HND, Degree'"
            v-model="formRef.level_5_qualification_subject"
            :error="formRef.errors.get('level_5_qualification_subject')"
        >
            <template v-slot:question>
                {{ getField("level_5_qualification_subject").question }}
            </template>
        </InputText>

        <InputMonthsYears
            v-if="formRef.highest_qualification_england_northern_ireland === 'Level 5+ e.g. HND, Degree'
            || formRef.highest_qualification_wales === 'Level 5+ e.g. HND, Degree'
            || formRef.highest_qualification_scotland === 'Level 5+ e.g. HND, Degree'"
            name="level_5_qualification_year"
            :required="true"
            :error="
                [formRef.errors.get('level_5_qualification_month'), formRef.errors.get('level_5_qualification_year')]
            "
            :years-label="getField('level_5_qualification_year').label"
            :months-label="getField('level_5_qualification_month').label"
            :years="formRef.level_5_qualification_year"
            @years-updated="formRef.level_5_qualification_year = $event"
            :months="formRef.level_5_qualification_month"
            @months-updated="formRef.level_5_qualification_month = $event"
        >
            <template v-slot:question>
                {{ getField("level_5_qualification_year").question }}
            </template>
        </InputMonthsYears>
    </div>
</template>

<script setup>
import InputRadioGroup from "../Form/InputRadioGroup";
import InputText from "../Form/InputText";
import InputMonthsYears from "../Form/InputMonthsYears";
import Form from "../../Form";
import { isRequired } from "./helpers";
import { ref, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

let formRef = markRaw(ref(new Form({
    where_complete_education: null,
    highest_qualification_england_northern_ireland: null,
    highest_qualification_scotland: null,
    highest_qualification_wales: null,
    achieved_five_gcses: null,
    has_gcse_english: null,
    has_gcse_maths: null,
    achieved_five_or_more_intermediate: null,
    has_intermediate_english: null,
    has_intermediate_maths: null,
    level_5_qualification: null,
    level_5_qualification_subject: null,
    level_5_qualification_year: null,
    level_5_qualification_month: null
}, props.formData)))

function handleRegionClear() {
    formRef.value.errors.clear('where_complete_education');
    formRef.highest_qualification_england_northern_ireland = null;
    formRef.highest_qualification_scotland = null;
    formRef.highest_qualification_wales = null;
    formRef.achieved_five_gcses = null;
    formRef.has_gcse_english = null;
}

function checkIsRequired(fieldName) {
    var fieldData = getField(fieldName);
    return isRequired(fieldData, formRef);
}

function getField(fieldName) {
    return props.fields[fieldName];
}

defineExpose({
  formRef
})
</script>
